import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import ResolvePopup from 'components/ResolvePopup';

import './TableControlButton.styles.scss';

type TableControlButtonProps = {
  className?: string;
  icon: React.ReactNode;
  tooltip?: string;
  disabled?: boolean;
  onClick?: () => void;
};

const TableControlButton: React.FC<TableControlButtonProps> = (props) => {
  const { className, icon, tooltip, disabled, onClick } = props;

  const classes = classNames('table-control-button', className);

  const button = useMemo(
    () => (
      <Button
        variant="icon"
        className={classes}
        icon={icon}
        aria-label={tooltip}
        disabled={disabled}
        {...(onClick && {
          onClick: (e) => {
            e.stopPropagation();
            onClick();
          },
        })}
      />
    ),
    [classes, icon, tooltip, disabled, onClick],
  );

  if (!tooltip) return button;

  return (
    <ResolvePopup onHover popupContent={tooltip}>
      {button}
    </ResolvePopup>
  );
};

export default TableControlButton;
